import { Component } from '@angular/core';

@Component({
  selector: 'transf-info-types',
  templateUrl: './transf-info-types.component.html',
})

export class TransfInfoTypes {
}
